import { render, staticRenderFns } from "./MaterialInventory.vue?vue&type=template&id=c25fffb2&"
import script from "./MaterialInventory.vue?vue&type=script&lang=js&"
export * from "./MaterialInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports